import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { F } from "@/lib/bricks";
import { Page, PageHeader, Section, List, Row, usePalette } from "@/components/calm/Calm";

const WIKI = "https://github.com/bricks-group/bricks-internal";

const SECTIONS = [
  { title: "Product", href: `${WIKI}/tree/main/product`, blurb: "Spine, surfaces and media rules." },
  { title: "Ops", href: `${WIKI}/tree/main/ops`, blurb: "Deploy rules, domains, Supabase and Vercel project names." },
  { title: "Security", href: `${WIKI}/tree/main/security`, blurb: "Connect honesty, calendar tokens, deferred Pro items." },
  { title: "Launch", href: `${WIKI}/tree/main/launch`, blurb: "Web and PWA path. App stores and Runpod are parked." },
  { title: "Hiring", href: `${WIKI}/tree/main/hiring`, blurb: "Photographer recruiting and the onboarding pack." },
  { title: "Legal inventory", href: `${WIKI}/blob/main/legal/README.md`, blurb: "Live agreements, protections and counsel gaps. Not public." },
  { title: "Contacts", href: `${WIKI}/tree/main/contacts`, blurb: "Support inboxes and agent roles. No secrets." },
];

const LEGAL = [
  "Public client: Terms and Privacy on www, accepted at booking.",
  "Photographers: IC Agreement v1.5 on apply (IP assignment, insurance, rate card, non-solicit).",
  "Gaps for counsel: IC classification review, SaaS MSA and DPA, entity on the minute book, IP assignment.",
  "Operational inventory only, not legal advice.",
];

export default function InternalDocsPage() {
  const { user } = useAuth();
  const { p } = usePalette();
  const link = { fontFamily: F.display, fontSize: 13, color: p.ink2, textDecoration: "underline", textUnderlineOffset: 3, textDecorationColor: p.hairS, whiteSpace: "nowrap" };

  // Belt-and-suspenders: OWNER_ONLY in App.js already redirects non-platform
  // workspaces; never render inventory for anyone without is_platform_owner.
  if (!user?.is_platform_owner) {
    return <Navigate to="/" replace />;
  }

  return (
    <Page width={760} testid="internal-docs">
      <PageHeader title="Internal docs" subtitle="Private ops and product notes. Visible to your platform account only." />
      <Section title="Library" note="Source of truth is the private bricks-internal repo.">
        <List>
          {SECTIONS.map((s) => (
            <Row key={s.title} title={s.title} meta={s.blurb}
              aside={<a href={s.href} target="_blank" rel="noopener noreferrer" style={link}>Open</a>} />
          ))}
        </List>
      </Section>
      <Section title="Legal snapshot" note="September 2026">
        <ul style={{ margin: 0, paddingLeft: 18, color: p.ink2, fontSize: 13.5, lineHeight: 1.6 }}>
          {LEGAL.map((l) => <li key={l}>{l}</li>)}
        </ul>
      </Section>
    </Page>
  );
}
